import script from "./paymentAmount.vue?vue&type=script&lang=tsx&setup=true"
export * from "./paymentAmount.vue?vue&type=script&lang=tsx&setup=true"

import "./paymentAmount.vue?vue&type=style&index=0&id=ded3c54e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ded3c54e"]])

export default __exports__